import { Component, ViewChild } from "@angular/core";
import { CreditLifeDesktopBenefitsDrawerComponent } from "./Benefits/desktop-benefits-drawer/creditLifeDesktopBenefitsDrawer.component";
import { CreditLifeDesktopPremiumDrawerComponent } from "./Premium/desktop-premium-drawer/creditLifeDesktopPremiumDrawer.component";
import { CreditLifeMobilePremiumDrawerComponent } from "./Premium/mobile-premium-drawer/creditLifeMobilePremiumDrawer.component";
import { CreditLifeMobileBenefitsDrawerComponent } from "./Benefits/mobile-benefits-drawer/creditLifeMobileBenefitsDrawer.component";
import { InsuranceHubService } from "src/app/services/Insurance-hub.service";
import { HttpErrorResponse } from "@angular/common/http";
import { InsuranceHubBaseComponent } from "../Insurance-hub-callback";
import { RouterModule } from "@angular/router";
@Component({
  selector: "app-credit-life",
  templateUrl: "./credit-life.component.html",
  styleUrls: ["./credit-life.component.css"],
  standalone: true,
  imports: [
    CreditLifeDesktopBenefitsDrawerComponent,
    CreditLifeMobileBenefitsDrawerComponent,
    CreditLifeDesktopPremiumDrawerComponent,
    CreditLifeMobilePremiumDrawerComponent,
    RouterModule
  ],
})
export class CreditLifeComponent extends InsuranceHubBaseComponent {
  @ViewChild("creditLifeDesktopBenefitsDrawer")
  creditLifeDesktopBenefitsDrawer!: CreditLifeDesktopBenefitsDrawerComponent;
  @ViewChild("creditLifeMobileBenefitsDrawer")
  creditLifeMobileBenefitsDrawer!: CreditLifeMobileBenefitsDrawerComponent;

  @ViewChild("creditLifeDesktopPremiumDrawer")
  creditLifeDesktopPremiumDrawer!: CreditLifeDesktopPremiumDrawerComponent;
  @ViewChild("creditLifeMobilePremiumDrawer")
  creditLifeMobilePremiumDrawer!: CreditLifeMobilePremiumDrawerComponent;

  private offcanvasInstances: { [key: string]: any } = {};

  drawerContent;
  ngOnInit(): void {
    this.GetPolicyDetailData();
  }

  GetPolicyDetailData() {
    let uPolicyData = sessionStorage.getItem("UserPolicyDetails")
      ? JSON.parse(sessionStorage.getItem("UserPolicyDetails"))
      : null;
    if (uPolicyData?.creditLifePolicyResponse) {
      this.PolicyDetailResponse = uPolicyData.creditLifePolicyResponse;
    }
  }
  openDesktopDrawer() {
    this.creditLifeDesktopBenefitsDrawer.openDrawer(this.PolicyDetailResponse);
  }

  openMobileDrawer() {
    this.creditLifeMobileBenefitsDrawer.openDrawer(this.PolicyDetailResponse);
  }

  openPremiumDesktopDrawer() {
    this.creditLifeDesktopPremiumDrawer.openDrawer(this.PolicyDetailResponse);
  }

  openPremiumMobileDrawer() {
    this.creditLifeMobilePremiumDrawer.openDrawer(this.PolicyDetailResponse);
  }
}
